<template>
  <div>
    <p>מתבצע עדכון...</p>
    <spinner></spinner>
  </div>
</template>

<script>
import getStatus from "../utils/getStatus";
import Spinner from "./spinner.vue";
export default {
  components: {
    Spinner,
  },
  data() {
    return {
      log: [],
      polling: null,
    };
  },
  methods: {
    async updateLog() {
      const log = await getStatus();
      if (log) {
        this.log = log;
      } else {
        this.$emit("build-error", "Cannot get status");
      }
    },
    pollStatus() {
      this.polling = window.setInterval(() => {
        this.updateLog();
      }, 10000);
    },
    checkTimeSinceStart() {
      const start = Number(this.log[1] + "000");
      const now = Date.parse(new Date());
      if (now - start < 600000) {
        return true;
      }
      return false;
    },
  },
  watch: {
    log() {
      // error time limit 10 minutes
      if (!this.checkTimeSinceStart()) {
        this.$emit("build-error", "build time exceeded limit");
      }

      // gridsome error
      const gError = this.log.find((line) => line.match("Error"));
      if (gError) {
        this.$emit("build-error", "Gridsome build failed");
      }

      // success
      if (
        this.log.length === 10 &&
        typeof parseInt(this.log[9]) === "number" &&
        this.log[5].match("Done in")
      ) {
        this.$emit("build-done", this.log);
      }
    },
  },
  beforeUnmount() {
    clearInterval(this.polling);
  },
  created() {
    this.pollStatus();
  },
};
</script>
